module.exports = __webpack_public_path__ + "img/installation-provider-bg.91c4c5f.png";